import {createStorefrontApiClient, StorefrontApiClient, ApiClientRequestOptions, ClientResponse} from '@shopify/storefront-api-client';


export class Shopify {

    private static instance: Shopify | undefined = undefined;
    static getInstance() {
        if(Shopify.instance === undefined) {
            Shopify.instance = new Shopify();
        }
        return Shopify.instance;
    }


    private client: StorefrontApiClient;

    constructor() {
        // Shopify client
        this.client = createStorefrontApiClient({
            storeDomain: 'z463c0-jq.myshopify.com',
            apiVersion: '2025-07',
            publicAccessToken: '3cdc7f4b39f498f067db81d27c337acc',
        });
    }

    async request(request: string, requestOpts?: ApiClientRequestOptions) : Promise<ClientResponse> {
        return this.client.request(request, requestOpts);
    }

    // Get specific vairant of by handle and matching options
    async getVariantByHandleAndOptions(productHandle: string, variantOptions: Array<{name: string, value: string}>) {
        // Use Shopify's GraphQL API to get the product by handle
        const query = `
            query getProductVariant($handle: String!, $options: [SelectedOptionInput!]!) {
            productByHandle(handle: $handle) {
                id
                title
                variantBySelectedOptions(selectedOptions: $options, ignoreUnknownOptions: true, caseInsensitiveMatch: true) {
                    id
                    price {
                        amount
                        currencyCode
                    }
                    selectedOptions {
                        name
                        value
                    }
                }
            }
            }`;
        
        const {data, errors, extensions} = await this.request(query, {
            variables: {
                handle: productHandle,
                options: variantOptions,
            },
        });

        if(!!errors) {
            console.error(errors);
            throw new Error(`Could not get variant for product=[${productHandle}] with options=[${variantOptions}]`);
        }

        return data;
    }

}